import { render, staticRenderFns } from "./addNewActivity.vue?vue&type=template&id=2756d532&scoped=true"
import script from "./addNewActivity.vue?vue&type=script&lang=js"
export * from "./addNewActivity.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addNewActivity.vue?vue&type=style&index=1&id=2756d532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756d532",
  null
  
)

export default component.exports